import { FileType } from 'global/enums/fileTypes';
import { ContractDeliverableStatus, ContractType, RecurrenceType } from './contract';
import { ConnectionFirstContact } from 'global/enums/connectionFirstContact';

export interface IChatUnread {
  numberUnread: number;
}

export enum ChatMessageType {
  Text = 0,
  Link = 1,
  Upload = 2,
  Payment = 3,
  PaymentSuccessful = 4,
  Review = 5,
  ReviewComplete = 6,
  ContractComplete = 7,
  ContractCancelled = 8,
  ConnectionAccepted = 9,
  ConnectionRemoved = 10,
  ConnectionAutoAccepted = 11,
  NewReviewAdded = 12,
  ContractRefunded = 13,
  PaymentFailed = 14,
  AcceptContract = 15,
  ContractAccepted = 16,
  ContractDeclined = 17,
  InvitationAccepted = 18,
}

export interface IChatMessage {
  id: string;
  userId: string;
  chatThreadId: string;
  userDisplayName: string;
  createdDateTime: string;
  content: string;
  messageType: ChatMessageType;
  files: IChatFile[];
  deliverables?: IChatDeliverable[];
  contract?: IChatContract;
  connection?: IChatConnection;
  actioned: boolean;
  visibleToUserId?: string;
  visibleToOtherUserId?: string;
}

export interface IChatMessageDisplay extends IChatMessage {
  messageTitle?: string;
  date?: string;
  time?: string;
  firstDate?: boolean;
  sending?: boolean;
  visibleMessage?: string;
  isSystemMessage?: boolean;
  systemIcon?: React.ReactNode;
  isTemporary?: boolean;
  error?: string;
  currentUserId?: string;
}

export interface IChatFile {
  chatThreadId: string;
  fileName: string;
  extension: string;
  fileType: FileType;
  thumbnailUrl?: string;
  url?: string;
  contentType?: string;
}

export interface IChatFileDisplay extends IChatFile {
  newLine?: boolean;
  loading?: boolean;
}

export interface IChatDeliverable {
  chatThreadId: string;
  contractId: string;
  contractName: string;
  name: string;
  status: ContractDeliverableStatus;
}

export interface IChatContract {
  contractId: string;
  contractType: ContractType;
  name: string;
  deliverables: string[];
  amount: number;
  buyerUserId: string;
  sellerUserId: string;
  completedOn: string;
  sellerRating?: number;
  buyerRating?: number;
  currency: string;
  recurrence?: RecurrenceType;
  firstPayment?: boolean;
  refundAmount?: number;
  refundTotal?: number;
  endDate?: string;
}

export interface IChatConnection {
  connectionId: string;
  actionUserId: string;
  actionUserDisplayName: string;
  otherUserId: string;
  otherUserDisplayName: string;
  firstContact: ConnectionFirstContact;
  packageName: string;
  description: string;
}

export interface IChatTyping {
  id: string;
  typingDisplayName: string;
  typingUserId: string;
}
